<template>
  <div class="wrap">
    <div class="content-area-full">
        <div class="dept_content clearfix">
           <div class="card-section" v-for="(entry, index) in entries" :key="entryKey(entry, index)">
             <div :id="entryKey(entry, index)" class="card-section-wrapper">
                 <div class="img-box">
                    <img 
                    :src="entry.cover == null ? url+'/assets/upload/'+entry.imgs_url.split(';')[0] : url+'/assets/upload/'+entry.cover"
                    oncontextmenu="return false;"
                    ondragstart="return false;"
                    oncopy="return false;"
                    onselect="return false"
                    ></img>
                 </div>
                 <div class="con-box">
                    <div class="info-row">
                        <span class="label">作品年份：</span>
                        <span class="">{{entry.year}}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">作品序号：</span>
                        <span class="">{{entry.eid}}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">作品名称：</span>
                        <span class="">{{entry.name}}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">作者姓名：</span>
                        <span class="">{{entry.username}}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">所属学校：</span>
                        <span class="">{{entry.school}}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">所在年级：</span>
                        <span class="">{{convertGrade(entry.gid)}}</span>
                    </div>
                    <div class="info-row">
                        <span class="label">指导老师：</span>
                        <span class="">{{entry.teacher}}</span>
                    </div>
                    <div class="primary-btn checkmore" v-if="expandedEntryKey == entryKey(entry, index)" @click="collapseEntry()">收起作品</div>
                    <div class="primary-btn checkmore" v-else @click="checkmore(entry, index)"> 查看作品</div>
                 </div>
             </div>
             <div v-if="expandedEntryKey == entryKey(entry, index)" class="imgs-box">
                <div class="img-box" v-for="(entryImg, index) in entry.imgs_url.split(';')" :key="index">
                    <img :src="url+'/assets/upload/'+entryImg"
                    oncontextmenu="return false;"
                    ondragstart="return false;"
                    oncopy="return false;"
                    onselect="return false"
                    ></img>
                </div>
                 <div v-if="entry.videos_url">
                  <div class="img-box" 
                    oncontextmenu="return false;"
                    ondragstart="return false;"
                    oncopy="return false;"
                    onselect="return false"
                    v-for="(entryVideo, index) in entry.videos_url.split(';')" :key="index">
                    <div class="zhezhao">
                    </div>
                    <video style="width: 960px;" controls>
                        <source :src="url +'/assets/upload/'+ entryVideo" type="video/mp4">
                        当前浏览器不支持该视频格式
                    </video>
                </div>
                 </div>
                <div class="collapse-btn toclick" @click="collapseEntry(entry, index)">收起作品</div>
             </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Loading } from 'element-ui'

export default {
  inject: ['reload'],
  data () {
    return {
      url: this.API,
      expandedEntryKey: '',
      entries: []
    }
  },
  components: {
  },
  created () {
    let _t = this;
    this._getData()
  },
  computed: {
    
  },
  mounted(){
  },
  methods: {
    _getData: function () {
      let _t = this
      let ld = Loading.service({'fullscreen': true, 'text': '数据加载中，请稍后'})
      axios.post(_t.API + '/api/work/entrylist/')
        .then(function (resp) {
          if (resp.data.code == '0') {
            _t.entries = resp.data.data
          } else {
            _t.$messagewarning(resp.data.msg)
            console.log(resp.data)
          }
          ld.close()
        })
        .catch(function (error) {
          console.log(error)
          ld.close()
        })
    },
    convertGrade: function (val) {
        if (val == '1') return '一年级'
        if (val == '2') return '二年级'
        if (val == '3') return '三年级'
        if (val == '4') return '赛道二'
    },
    entryKey: function (entry, index) {
        return 'entry-' + entry.year + '-' + entry.eid + '-' + index
    },
    collapseEntry: function(entry, index) {
        var targetKey = entry ? this.entryKey(entry, index) : ''
        this.expandedEntryKey = ''
        if (targetKey) {
            this.$nextTick(function () {
                var target = document.getElementById(targetKey)
                if (target) target.scrollIntoView()
            })
        }
    },
    checkmore: function (entry, index) {
        this.expandedEntryKey = this.entryKey(entry, index)
    }
  }
}
</script>
<style scoped lang='stylus'>
@import '~@/common/stylus/index'

 
.zhezhao{
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0.5;
    }

.clearfix:after{
  content:"";
  clear:both;
}
.clearfix{
  *zoom: 1;
}
.wrap{
    text-align: center;
}
p{
    font-family: sylight;
    color:black;
    font-size: 17px;
    text-align: justify;
    line-height: 1.8em;
    margin-top:30px;
    text-indent: 2em;
}
.content-area-full{
    margin-top: 60px;
}
.dept_content{
    margin-top:50px; 
}
.card-section{
    padding: 0 calc((100% - 1024px) / 2);
    background-color: #f2f6fa;
}
.info-row{
    margin-bottom: 5px;
    display: flex;
}
.card-section-wrapper{
    display: flex;
    padding: 50px 0;
    .img-box{
      width: 400px;
      height: 100%;
      margin-right: 60px;
      overflow: hidden;
    }

    .img-box img{
      width: 100%;
      height: auto;
    }
    
    .con-box{
      text-align: left;
      margin: 60px 0;
      width: calc(100% - 604px);
      .name{
        font-size: 22px;
        color: black;
      }
      .label{
        width: 100px;
      }
      .checkmore{
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        display: inline-block;
        background-color: #25335e;
        text-align: center;
        margin-top: 20px;
      }
    }
}
.card-section:nth-child(2n){
    background-color: white;
    .card-section-wrapper{
       display: flex;
       flex-direction: row-reverse;
       .con-box{
          text-align: right;
          margin: 60px 60px 60px 0;
          max-width: calc(100% - 604px);
          width: auto;
          .label{
            text-align: left;
          }
       }
   }
}
.imgs-box .img-box{
    text-align: center;
    margin-bottom: 20px;
    img {
        width: 800px;
    }
}
.collapse-btn {
    padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// Entry.vue?53140d68